import redirectToOnboardingIfRequired from "@/shared/router/guards/redirectToOnboardingIfRequired";

export default {
  default: [
    {
      path: "/aanvragen-krediet-faciliteit",
      name: "credit.limit.request",
      component: () => import("@/modules/creditLimitRequest/views/CreditLimitRequestView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    }
  ]
};
